<template>
	<div class="tab_container">
		<div id="tab_item" v-for="option in options" :key="option.value" :class="`tab_item ${option.value === activeKey ? 'heading_7' : 'body_6 f_gray_4'
			}`
			" @click="() => handleChange(option.value)" ref="tabItems">
			{{ option.label }}
		</div>
		<div class="tab_indicator" :style="indicatorStyle" />
	</div>
</template>

<script>
export default {
	data() {
		return {
			indicatorStyle: {
				width: '0px',
				transform: 'translateX(0px)'
			},
			windowWidth: window.innerWidth
		}
	},
	props: {
		options: {
			type: Array
		},
		activeKey: {
			type: String
		},
		onChange: {
			type: Function
		}
	},
	watch: {
		activeKey() {
			this.updateIndicator()
		},
		windowWidth(newWidth) {
			// 원하는 로직 추가
		}
	},
	methods: {
		handleChange(value) {
			if (this.onChange) {
				this.onChange(value)
			}
		},
		updateIndicator() {
			const findIndex = this.options.findIndex(
				option => option.value === this.activeKey
			)

			if (findIndex > -1 && !!this.$refs.tabItems) {
				const tab = this.$refs.tabItems[findIndex]
				if (tab) {
					this.indicatorStyle = {
						width: `${tab.offsetWidth}px`,
						transform: `translateX(${tab.offsetLeft - 12}px)`
					}
				}
			}
		}
	},
	mounted() {
		this.updateIndicator()
		window.addEventListener('resize', this.updateIndicator)
	},
	beforeDestroy() {
		window.removeEventListener('resize', this.updateIndicator)
	}
}
</script>

<style scoped>
.tab_container {
	position: relative;
	display: flex;
	align-items: center;
	width: 100%;
	padding: 0 12px;
	border-bottom: 1px solid var(--gray-scale-7);
	background-color: var(--gray-scale-12);
	overflow-x: scroll;
	white-space: nowrap;
	-ms-overflow-style: none;
	/* IE and Edge */
	scrollbar-width: none;
	/* Firefox */
}

.tab_container::-webkit-scrollbar {
	display: none;
}

.tab_container>.tab_item {
	text-align: center;
	width: 100%;
	padding: 16px 20px;
	transition: color 0.3s;
}

.tab_container>.tab_indicator {
	position: absolute;
	bottom: 0;
	height: 2px;
	background-color: var(--gray-scale-2);
	border-radius: 100px;
	transition: transform 0.3s;
}
</style>



// WEBPACK FOOTER //
// src/components/ai/AiTab.vue